module.exports = __webpack_public_path__ + "static/media/cosentino-message.98db3c2c.svg";